import axios from "axios";

const instance = axios.create({
  baseURL: "https://react-burger-app987-default-rtdb.firebaseio.com/",
});

export default instance;



// WEBPACK FOOTER //
// ./src/axios-orders.js